import dayjs from 'dayjs'

const MAX_SEARCH_MONTHS = 18
const MAX_GUESTS = 5
const DEFAULT_NIGHTS = 3
const parseIncomingParams = ({ params, properties, promos }) => {
  const results = {
    startDate: dayjs.tz().add(1, 'days').format('YYYY-MM-DD'),
    endDate: dayjs
      .tz()
      .add(1 + DEFAULT_NIGHTS, 'days')
      .format('YYYY-MM-DD'),
    hotelCode: '',
    ratePlanCode: params.ratePlanCode || '',
    roomTypeCode: params.roomTypeCode || '',
    rooms: [],
    promoCode: '',
  }

  // GUESTS
  const {
    adults: adultsParam,
    children: childrenParam,
    startDate,
    endDate,
    numberOfNights,
    hotelCode,
    rooms,
    promoCode,
    promoCodes,
  } = params

  if (adultsParam || childrenParam) {
    const adults = parseInt(adultsParam, 10)
    const children = parseInt(childrenParam, 10)
    const totalRequestedGuests = +(adults || 0) + +(children || 0)
    const room = {
      adults: adults && totalRequestedGuests <= MAX_GUESTS ? adults : 2,
      children: children && totalRequestedGuests <= MAX_GUESTS ? children : 0,
    }
    results.rooms.push(room)
  } else if (rooms?.match(/adults=\d+&children=\d+/g)) {
    const guestsParams = new URLSearchParams(rooms)
    results.rooms.push({
      adults: parseInt(guestsParams.get('adults'), 10) || 2,
      children: parseInt(guestsParams.get('children'), 10) || 0,
    })
  } else if (rooms) {
    rooms?.split(',')?.forEach((room) => {
      const guests = room?.split('|')
      results.rooms.push({
        adults: parseInt(guests[0], 10) || 2,
        children: parseInt(guests[1], 10) || 0,
      })
    })
  } else {
    results.rooms.push({
      adults: 2,
      children: 0,
    })
  }

  // DATES
  // start is after today, isBefore MAX_SEARCH_MONTHS
  if (
    startDate &&
    dayjs.tz(startDate).isAfter(dayjs.tz()) &&
    dayjs.tz(startDate).isBefore(dayjs.tz().add(MAX_SEARCH_MONTHS, 'months'))
  ) {
    results.startDate = startDate
    results.endDate = dayjs
      .tz(startDate)
      .add(+numberOfNights || DEFAULT_NIGHTS, 'days')
      .format('YYYY-MM-DD')
  }

  if (endDate && dayjs.tz(endDate).isAfter(dayjs.tz(results.startDate))) {
    results.endDate = endDate
  }

  // ACCOMMODATIONS
  if (hotelCode && properties[hotelCode]) {
    results.hotelCode = hotelCode
  }

  const promoInput = promoCode || promoCodes || ''
  if (promoInput && promos?.length) {
    const promoData = promos.find(
      (promo) =>
        promo?.id && promo.id.toUpperCase() === promoInput.toUpperCase()
    )

    if (promoData) {
      results.promoCode = promoInput.toUpperCase()
    }
  }
  return results
}

export default parseIncomingParams
